import { createSelector } from 'reselect';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentState, StoreState } from '../types/StoreState';
import {
  selectIsPayPalButtonAvailable,
  selectIsPayLaterBtnAvailable,
  selectIsCreditBtnAvailable,
  selectIsVenmoBtnAvailable,
} from './payPal';
import { selectApplePayButtonAvailable } from './applePay';
import { selectLoadPayPalScriptState } from './requestsState';
import { selectGooglePayButtonAvailable } from './googlePay';

export const selectPaymentState = (state: StoreState) => state.payment;

export const selectPayPalOrderId = createSelector(
  selectPaymentState,
  (payment: PaymentState) => payment && payment[PaymentMethod.PayPal].orderId,
);

export const selectPayPalShippingContact = createSelector(
  selectPaymentState,
  (payment: PaymentState) => payment && payment[PaymentMethod.PayPal].shippingContact,
);

export const selectAvailablePmsList = createSelector(
  selectGooglePayButtonAvailable,
  selectApplePayButtonAvailable,
  selectLoadPayPalScriptState,
  selectIsPayPalButtonAvailable,
  selectIsPayLaterBtnAvailable,
  selectIsCreditBtnAvailable,
  selectIsVenmoBtnAvailable,
  (hasGooglePay, hasApplePay, scriptState, payPal, payLater, credit, venmo) => {
    const list = {
      googlePay: hasGooglePay,
      applePay: hasApplePay,
      payPal: [] as string[],
    };
    if (scriptState === 'fulfilled') {
      const { PAYPAL, PAYLATER, CREDIT, VENMO } = window.paypal.FUNDING;
      if (payPal) {
        list.payPal.push(PAYPAL);
      }
      if (payLater) {
        list.payPal.push(PAYLATER);
      }
      if (credit) {
        list.payPal.push(CREDIT);
      }
      if (venmo) {
        list.payPal.push(VENMO);
      }
    }
    return list;
  },
);
